import script from "./DeathDescription.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeathDescription.vue?vue&type=script&lang=ts&setup=true"

import "./DeathDescription.vue?vue&type=style&index=0&id=c05374a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c05374a6"]])

export default __exports__